import { useState } from "react";
import { reviews } from "@/mocks/reviews";

export default function ReviewsSection() {
  const [currentIdx, setCurrentIdx] = useState(0);
  const review = reviews[currentIdx];

  const goNext = () => {
    setCurrentIdx((prev) => (prev + 1) % reviews.length);
  };

  const goPrev = () => {
    setCurrentIdx((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  const reviewSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "USFansSpreadsheet",
    "description": "Nowoczesne narzędzie do zarządzania arkuszami kalkulacyjnymi z zaawansowaną automatyzacją.",
    "review": reviews.map((r) => ({
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": r.rating,
        "bestRating": "5",
      },
      "author": {
        "@type": "Person",
        "name": r.name,
      },
      "reviewBody": r.text,
    })),
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1),
      "reviewCount": reviews.length,
      "bestRating": "5",
    },
  };

  return (
    <section className="relative w-full bg-background-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 lg:gap-16 items-center">
          <div className="w-full lg:w-[40%] flex-shrink-0">
            <div className="rounded-3xl overflow-hidden aspect-[3/4] bg-secondary-100">
              <img
                src={review.avatar}
                alt={review.name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-[60%] flex flex-col">
            <span className="text-xs md:text-sm text-accent-600 font-medium mb-4 tracking-wide">
              (Recenzje użytkowników)
            </span>

            <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight mb-8 md:mb-10">
              <span className="text-foreground-950">Opinie o</span>{" "}
              <span className="text-foreground-300">USFansSpreadsheet</span>
            </h2>

            <blockquote className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 md:mb-8 max-w-lg">
              &ldquo;{review.text}&rdquo;
            </blockquote>

            <p className="text-sm font-semibold text-foreground-900 mb-6 md:mb-8">
              – {review.name}, <span className="text-foreground-500 font-normal">{review.role}</span>
            </p>

            <div className="flex items-center gap-1 mb-8">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className={`${i < review.rating ? "ri-star-fill text-primary-500" : "ri-star-line text-foreground-300"} w-4 h-4 flex items-center justify-center`}
                ></i>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <button
                onClick={goPrev}
                className="whitespace-nowrap cursor-pointer w-10 h-10 rounded-full border-2 border-foreground-200 text-foreground-400 flex items-center justify-center hover:border-foreground-400 hover:text-foreground-600 transition-colors"
                aria-label="Poprzednia recenzja"
              >
                <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
              </button>
              <button
                onClick={goNext}
                className="whitespace-nowrap cursor-pointer w-10 h-10 rounded-full bg-foreground-950 text-background-50 flex items-center justify-center hover:bg-foreground-800 transition-colors"
                aria-label="Następna recenzja"
              >
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(reviewSchema) }}
      />
    </section>
  );
}